import React from 'react'

const Spinner = () => {
  return (
    <div uk-spinner="true"></div>
  )
}

export default Spinner
